export enum HandoffType {
  loading = -1,
  pickup,
  curbside,
  delivery,
  dispatch,
  driveThru,
  dineIn,
}
